var React = require('react');

function RocketIconInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"nonzero"},[React.createElement("path",{"d":"M18.5 13c-2.52 0-4.5 1.98-4.5 4.5s1.98 4.5 4.5 4.5 4.5-1.98 4.5-4.5-1.98-4.5-4.5-4.5zm0 7.198c-1.53 0-2.7-1.17-2.7-2.7 0-1.53 1.17-2.7 2.7-2.7 1.53 0 2.7 1.17 2.7 2.7 0 1.53-1.17 2.7-2.7 2.7z","key":0}),React.createElement("path",{"d":"M27.749 33.282v-17.25c0-5.25-3.422-12.376-9.25-16.032-5.827 3.656-9.25 10.781-9.25 16.125v17.25L0 45h37l-9.25-11.72-.001.002zM9.248 43.126H3.883l5.365-6.843v6.843zm16.65 0h-14.8V16.125c0-4.219 2.59-10.313 7.401-13.875 4.81 3.563 7.4 9.563 7.4 13.875v27.001zm1.85-6.843l5.365 6.843H27.75v-6.843zM17 47h2v9h-2zM22 46h2v6h-2zM13 46h2v6h-2v-6z","key":1})]));
}

RocketIconInline.defaultProps = {"width":"37","height":"56","viewBox":"0 0 37 56"};

module.exports = RocketIconInline;

RocketIconInline.default = RocketIconInline;
